import React from "react";

interface SpeechBubbleProps {
  children: React.ReactNode;
  className?: string;
}

const SpeechBubble: React.FC<SpeechBubbleProps> = ({ children, className }) => (
  <div className={`text-lg p-4 relative inline-block bg-white border-2 border-var(--color-grey-light) rounded-xl text-center shadow-sm max-w-[340px] ${className || ""}`}>
    {children}
    <div className="absolute left-1/2 -bottom-[18px] -translate-x-1/2 w-8 h-[18px] overflow-hidden">
      <div className="w-6 h-6 bg-white border-l-2 border-b-2 border-var(--color-grey-light) -translate-x-1/2 -rotate-45 absolute left-1/2 -top-[14px]"></div>
    </div>
  </div>
);

export default SpeechBubble;
